import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function DashboardActiveMainLeaderboard({value, leaderboard, userData}) {
    const [isVisible, setIsVisible] = useState(false);

    const getRainIntensityIcon = (v) => {
        const icon_name = v === 0 ? "wb_sunny"
                        : v === 1 || v === 2 || v === 3 ? "rainy"
                        : v === 4 || v === 5 ? "thunderstorm"
                        : "wb_sunny"

        return `${icon_name}`;
    };

    const trackStatus = {
        0: "Green",
        1: "Fast",
        2: "Optimum",
        3: "Greasy",
        4: "Damp",
        5: "Wet",
        6: "Flooded",
    }[value["track-grip-status"]] || "Uknown";

    const formatTime = (ms) => {
        if (ms === "∞") return ms;

        const h = Math.floor(ms / 3600000);
        const m = Math.floor((ms % 3600000) / 60000);
        const s = Math.floor((ms % 60000) / 1000);

        const mm = m < 10 ? `0${m}` : m;
        const ss = s < 10 ? `0${s}` : s;

        if (h > 0) {
            return `${h}:${mm}:${ss}`;
        } else {
            return `${m}:${ss}`;
        }
    };

    const sessionName = {
        0: "Practice",
        1: "Qualify",
        2: "Race",
        3: "HotLap",
        4: "Time Attack",
        5: "Drift",
        6: "Drag",
        7: "Hot Stint",
        8: "Hot Stint SuperPole"
    }[value["session-type"]] || "Uknown";

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Tab') {
                e.preventDefault();
                setIsVisible(true);
            }

            if (e.key === 'Escape') {
                e.preventDefault();
                setIsVisible(false);
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
        window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    if (!isVisible) {
        return null;
    }

    return (
        <div className="fixed z-[999] flex min-h-screen w-full flex-col items-center justify-center bg-black/40 backdrop-blur-sm p-4 md:p-8">

            <div className="w-full max-w-7xl mb-6 flex flex-col items-center">
                <div className="flex items-center gap-3 mb-2">
                    <div className="size-8 bg-primary rounded-lg flex items-center justify-center shadow-lg shadow-primary/20">
                        <span className="material-symbols-outlined text-white text-xl">speed</span>
                    </div>
                    <h2 className="text-white text-xl font-bold tracking-tight uppercase italic">LiveTelemetry</h2>
                </div>
                <h1 className="text-4xl md:text-5xl font-bold tracking-tighter text-white text-center uppercase">Session Leaderboard</h1>
                <div className="mt-2 flex items-center gap-2 bg-white/10 px-3 py-1 rounded-full border border-white/10">
                    <span className="text-xs font-medium text-white/60 tracking-widest uppercase">Press</span>
                    <span className="text-xs font-bold text-white bg-white/20 px-1.5 py-0.5 rounded leading-none">ESC</span>
                    <span className="text-xs font-medium text-white/60 tracking-widest uppercase">to close</span>
                </div>
            </div>

            <div className="w-full max-w-7xl bg-[#16212c]/90 border border-primary/20 rounded-xl shadow-2xl overflow-hidden backdrop-blur-md">
                <div className="overflow-x-auto max-h-[520px]">
                    <table className="w-full text-left border-collapse">
                        <thead className="top-0 sticky z-10">
                            <tr className="bg-[#112941ff] border-b border-primary/30 z-10">
                                <th className="px-6 py-4 text-xs font-bold text-primary uppercase tracking-widest">#</th>
                                <th className="px-6 py-4 text-xs font-bold text-primary uppercase tracking-widest">Driver Name</th>
                                <th className="px-6 py-4 text-xs font-bold text-primary uppercase tracking-widest text-center">Car</th>
                                <th className="px-6 py-4 text-xs font-bold text-primary uppercase tracking-widest text-center">Laps</th>
                                <th className="px-6 py-4 text-xs font-bold text-primary uppercase tracking-widest text-right">Interval</th>
                                <th className="px-6 py-4 text-xs font-bold text-primary uppercase tracking-widest text-right">Best Lap</th>
                                <th className="px-6 py-4 text-xs font-bold text-primary uppercase tracking-widest text-right">Last Lap</th>
                                <th className="px-6 py-4 text-xs font-bold text-primary uppercase tracking-widest text-center">Status</th>
                                <th className="px-6 py-4 text-xs font-bold text-primary uppercase tracking-widest text-center">Pits</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-white/5">
                            {userData.subscription === "pro" ? (
                                (() => {
                                    const PLAYER_FULL_NAME = `${value["player-name"]} ${value["player-surname"]}`;

                                    const uniqueDrivers = Object.values(
                                        leaderboard.reduce((acc, driver) => {
                                            acc[driver["car-id"]] = driver;
                                            return acc;
                                        }, {})
                                    );

                                    const sortedLeaderboard = uniqueDrivers.sort((a, b) => a.position - b.position);

                                    return sortedLeaderboard.map((driver) => {
                                        const isPlayer = driver.name === PLAYER_FULL_NAME;

                                        return (
                                            <tr
                                            key={driver["car-id"]}
                                            className={`transition-colors border-l-4 ${
                                                isPlayer
                                                    ? "bg-primary/20 border-l-primary group"
                                                    : "hover:bg-white/5 border-l-transparent"
                                            }`}
                                            >
                                                <td className={`px-6 py-4 mono-numbers text-lg font-bold ${isPlayer ? "text-white" : "text-white/60"}`}>
                                                    {driver.position}
                                                </td>

                                                <td className="px-6 py-4">
                                                    <div className="flex items-center gap-3">
                                                        {isPlayer && <div className="size-2 rounded-full bg-primary animate-pulse"></div>}
                                                        <span className={`font-bold text-lg ${isPlayer ? "text-white" : "text-white/80"}`}>
                                                            {driver.name} {isPlayer && "(YOU)"}
                                                        </span>
                                                    </div>
                                                </td>

                                                <td className="px-6 py-4 text-center text-white/60 mono-numbers">#{driver["car-number"]}</td>
                                                <td className="px-6 py-4 text-center text-white/80 mono-numbers">{driver.laps}</td>

                                                <td className={`px-6 py-4 text-right font-bold tracking-tight ${isPlayer ? "text-primary" : "text-white/80"}`}>
                                                    {driver.position === 1 ? "LEADER" : `${driver.gap >= 0 ? "+" : ""}${driver.gap}s`}
                                                </td>

                                                <td className={`px-6 py-4 text-right mono-numbers font-bold ${driver["has-best-lap"] ? "text-primary" : isPlayer ? "text-primary" : "text-white/80"}`}>
                                                    {driver["best-lap"]}
                                                </td>
                                            
                                                <td className="px-6 py-4 text-right mono-numbers text-white/80">
                                                    {driver["last-lap"]}
                                                </td>

                                                <td className="px-6 py-4 text-center">
                                                    {driver.status === "track" ? (
                                                        <span className="px-3 py-1 rounded bg-green-500/20 text-green-400 text-[10px] font-bold tracking-widest uppercase border border-green-500/30">
                                                            Track
                                                        </span>
                                                    ) : (
                                                        <div className="flex items-center justify-center gap-1.5 px-3 py-1 rounded bg-amber-500/20 text-amber-400 text-[10px] font-bold tracking-widest uppercase border border-amber-500/30">
                                                            <span className="material-symbols-outlined text-sm">hail</span>
                                                            <span>In Pits</span>
                                                        </div>
                                                    )}
                                                </td>

                                                <td className="px-6 py-4 text-center text-white/60 mono-numbers">{driver.pits}</td>
                                            </tr>
                                        );
                                    });
                                })()

                            ) : (
                                <>
                                    <tr className="hover:bg-white/5 transition-colors">
                                        <td className="px-6 py-4 mono-numbers text-white/60">2</td>
                                        <td className="px-6 py-4 text-white font-medium">L. Hamilton</td>
                                        <td className="px-6 py-4 text-center text-white/60 mono-numbers">#44</td>
                                        <td className="px-6 py-4 text-right text-white/80 mono-numbers">+0.432</td>
                                        <td className="px-6 py-4 text-right text-white/80 mono-numbers">+0.432</td>
                                        <td className="px-6 py-4 text-right mono-numbers text-white/80">1:47.210</td>
                                        <td className="px-6 py-4 text-right mono-numbers text-white/80">1:47.550</td>
                                        <td className="px-6 py-4 text-center">
                                            <span className="px-3 py-1 rounded bg-green-500/20 text-green-400 text-[10px] font-bold tracking-widest uppercase border border-green-500/30">Track</span>
                                        </td>
                                        <td className="px-6 py-4 text-center text-white/60 mono-numbers">1</td>
                                    </tr>

                                    <tr className="hover:bg-white/5 transition-colors bg-white/2">
                                        <td className="px-6 py-4 mono-numbers text-white/60">3</td>
                                        <td className="px-6 py-4 text-white font-medium">K. Estre</td>
                                        <td className="px-6 py-4 text-center text-white/60 mono-numbers">#92</td>
                                        <td className="px-6 py-4 text-right text-white/80 mono-numbers">+1.102</td>
                                        <td className="px-6 py-4 text-right text-white/80 mono-numbers">+0.670</td>
                                        <td className="px-6 py-4 text-right mono-numbers text-primary/80">1:47.055</td>
                                        <td className="px-6 py-4 text-right mono-numbers text-white/40">1:58.002</td>
                                        <td className="px-6 py-4 text-center">
                                            <div className="flex items-center justify-center gap-1.5 px-3 py-1 rounded bg-amber-500/20 text-amber-400 text-[10px] font-bold tracking-widest uppercase border border-amber-500/30">
                                                <span className="material-symbols-outlined text-sm">hail</span>
                                                <span>In Pits</span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 text-center text-white/60 mono-numbers">2</td>
                                    </tr>
                                </>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="bg-black/40 px-6 py-3 flex flex-wrap justify-between items-center border-t border-white/10 gap-4">
                    <div className="flex gap-8">
                        <div className="flex flex-col">
                            <span className="text-[10px] font-bold text-white/40 uppercase tracking-widest">Track Condition</span>
                            <span className="text-sm font-medium text-white flex items-center gap-1">
                                <span className="material-symbols-outlined text-xs text-primary">{getRainIntensityIcon(value["10-rain-intensity"])}</span>
                                {trackStatus} - {Math.round(value["road-data:road-temp"])}°C
                            </span>
                        </div>
                        <div className="flex flex-col">
                            <span className="text-[10px] font-bold text-white/40 uppercase tracking-widest">Air Temp</span>
                            <span className="text-sm font-medium text-white flex items-center gap-1">
                                <span className="material-symbols-outlined text-xs text-primary">thermostat</span>
                                {Math.round(value["road-data:air-temp"])}°C
                            </span>
                        </div>
                    </div>
                    <div className="flex items-center gap-4">
                        <div className="flex flex-col items-end">
                            <span className="text-[10px] font-bold text-white/40 uppercase tracking-widest">Time Remaining</span>
                            <span className="text-xl font-bold text-white mono-numbers">{formatTime(value["time-left"])}</span>
                        </div>
                        <div className="h-8 w-[1px] bg-white/10"></div>
                        <div className="flex flex-col items-end">
                            <span className="text-[10px] font-bold text-white/40 uppercase tracking-widest">Current Session</span>
                            <span className="text-sm font-bold text-primary uppercase italic">{sessionName}</span>
                        </div>
                    </div>
                </div>

                {userData.subscription !== "pro" && 
                    <div className="absolute w-full h-full inset-0 flex items-center justify-center">
                        <div className="flex justify-center flex-col items-center bg-[#1c2a38b3] h-full backdrop-blur-sm border border-primary/40 rounded-2xl p-8 w-full text-center shadow-2xl ring-1 ring-white/10">
                            <div className="inline-flex items-center justify-center size-14 rounded-full bg-primary/20 mb-4">
                                <span className="material-symbols-outlined text-primary text-3xl">lock</span>
                            </div>
                            <Link to="/subscription-plans">
                            <button className="w-full bg-primary hover:bg-primary/90 text-white font-bold py-3.5 px-6 rounded-lg transition-all transform hover:scale-[1.02] active:scale-95 shadow-lg shadow-primary/20 uppercase tracking-widest text-sm">
                                Upgrade to Pro
                            </button>
                            </Link>
                            <p className="mt-4 text-[10px] text-white/30 uppercase tracking-widest font-medium">At $4.99 for Life</p>
                        </div>
                    </div>
                }
            </div>

            <div className="mt-8 flex items-center gap-2 text-white/40">
                <span className="material-symbols-outlined text-sm animate-pulse">info</span>
                <span className="text-xs font-medium uppercase tracking-widest">Leaderboard updates every 1.0s</span>
            </div>
        </div>
    );
}

export default DashboardActiveMainLeaderboard;